export { default } from "./ParentTeacherWritePrompt";
